module.exports = __webpack_public_path__ + "static/media/howabout1_new2.ad334591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howabout1_new2.png
// module id = 6850
// module chunks = 0